import { getArticleFromList } from "@pb/utils/onClick";
const handleClickForBrand = ({ event, productSet, praConfiguration, origin, carouselTitle, }) => {
    var _a;
    const productDataSet = getArticleFromList(event, productSet);
    if (!productDataSet || !praConfiguration) {
        return;
    }
    const { TRACKING, SOURCE, BRAND } = praConfiguration;
    const { articleCode, category, title, redPriceValue, regularPriceValue, origin: productOrigin, atelierName, variantColor, trackingInfo, } = productDataSet;
    const storiesBrandAlignForTracking = BRAND === 'otherstories' ? 'stories' : BRAND;
    const productIndex = productSet.indexOf(productDataSet);
    const finalData = {
        list_name: carouselTitle || '',
        list_filter: '',
        list_action: TRACKING.CLICK,
        list_sorting: '',
        imp_brand: [storiesBrandAlignForTracking || ''],
        imp_position: [productIndex + 1],
        imp_id: [`${articleCode}` || ''],
        imp_name: [(title === null || title === void 0 ? void 0 : title.toUpperCase()) || ''],
        imp_category: [category || ''],
        imp_price: [`${redPriceValue || regularPriceValue || ''}`],
        imp_original_price: [`${regularPriceValue || ''}`],
        imp_atelier: [atelierName || ''],
        imp_variant: [variantColor || ''],
        imp_origin_system: [productOrigin || ((origin === null || origin === void 0 ? void 0 : origin.length) && origin) || SOURCE || ''],
        imp_color: [variantColor || ''],
        imp_origin: [''],
    };
    if (trackingInfo === null || trackingInfo === void 0 ? void 0 : trackingInfo.ticketId) {
        sessionStorage.setItem(`ticket_${articleCode}`, trackingInfo.ticketId);
    }
    // brand tealium setup is different from HM
    (_a = window.TealiumUtils) === null || _a === void 0 ? void 0 : _a.utagTrackEventLink('', '', '', finalData);
};
export default handleClickForBrand;
//# sourceMappingURL=handleClickForBrand.js.map